export const NET_DEBT_RANK = -1;
export const MAX_COLLAPSED_ITEMS = 5;
export const MAX_LABEL_ITEMS = 5;
export const MAX_PAGE_ITEMS = 5;

export const NET_DEBT_TYPE = 'NetDebt';
